import React, { PropsWithChildren } from 'react';

import { FeatureFlagsContext } from '@/contexts/featureFlagsContext/FeatureFlags.context.ts';
import { useGetDisabledFeatureFlags } from '@/contexts/featureFlagsContext/util/useGetDisabledFeatureFlags.util.ts';

export const FeatureFlagsContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const { disabledFlags } = useGetDisabledFeatureFlags();

  return (
    <FeatureFlagsContext.Provider value={disabledFlags}>{children}</FeatureFlagsContext.Provider>
  );
};
